import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentStep: 1,
  completed: {
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
  },
  hiddenSteps: {
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
  },
};

const stepperSlice = createSlice({
  name: "stepper",
  initialState,
  reducers: {
    goToStep: (state, action) => {
      state.currentStep = action.payload;
    },
    nextStep: (state) => {
      state.currentStep += 1;
    },
    prevStep: (state) => {
      state.currentStep -= 1;
    },
    completeStep: (state, action) => {
      const { step } = action.payload;
      state.completed[step] = true;
    },
    resetSteps: (state) => {
      state.currentStep = 1;
      state.completed = {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
      };
      state.hiddenSteps = {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
      };
    },

    hideStep: (state, action) => {
      const { step } = action.payload;
      state.hiddenSteps[step] = true;
    },
    showStep: (state, action) => {
      const { step } = action.payload;
      state.hiddenSteps[step] = false;
    },
  },
});

export const {
  goToStep,
  nextStep,
  prevStep,
  completeStep,
  resetSteps,
  hideStep,
  showStep,
} = stepperSlice.actions;

export const selectCurrentStep = (state) => state.stepper.currentStep;
export const selectStepCompletion = (state) => state.stepper.completed;
export const selectHiddenSteps = (state) => state.stepper.hiddenSteps;

export default stepperSlice.reducer;
